import api from '../token';

export const ListVeiculo = async () => {
  try {
    const response = await api.post('/getVeiculo');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

